import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Table, { Column } from "../../../Components/Tables/Table";
import { adjustmentdetailslist, HistoryLaoutAdjustmentDetails } from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import HistoryLayout from "../../../Layout/HistoryLaout";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";

export default function AdjustmentDetails() {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const pageName = `Inventory Adjustment History (${id})`;
    const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
    const toggleCollapse = (index: number) => {
        const updatedCollapseStates = [...collapseStates];
        updatedCollapseStates[index] = !updatedCollapseStates[index];
        setCollapseStates(updatedCollapseStates);
    };

    const [isShowCanvas, setShowCanvas] = useState(false);
    const handelCanvas = () => {
       setShowCanvas(!isShowCanvas);
    };
    const historyData = (
        <>
            <div
                className="d-flex justify-content-between w-100 align-items-center px-4"
                onClick={handelCanvas}
            >
                <div>
                    <h6 className="cursor-pointer m-0 d-flex align-items-center">
                        <img src={historyIcon} className="me-2" />
                        History
                    </h6>
                </div>
            </div>
        </>
    );
    const columns: Column[] = [
        {
            name: "Line#",
            selector: (row: { line: string }) => row.line,
        },
        {
            name: "Item Code",
            selector: (row: { itemCode: string }) => row.itemCode,
        },
        {
            name: "Item Description",
            selector: (row: { itemDesc: string }) =>  (
                <span   title={row.itemDesc.length > 15 ? row.itemDesc : ""}>
                {row.itemDesc.length > 15
                  ? `${row.itemDesc.slice(0, 15)}...`
                  : row.itemDesc}
              </span>
            ),
        },
        {
            name: "UOM",
            selector: (row: { uom: string }) => row.uom,
        },
        {
            name: "Adjusted Qty",
            selector: (row: { adjustedQty: string }) => row.adjustedQty,
        },
        {
            name: "Bin Location",
            selector: (row: { binLocation: string }) => row.binLocation,
        }
    ];

    const InventoryAdjustmentHistoryData=[
        {label: "Created By", value: "John William"},
        {label: "Created Date", value: "03/15/2023"},
        {label: "Completed Date", value: "03/16/2020"},
        {label: "Inv. Status", value: "Finished Goods"},
        {label: "Reason Code", value: "1232"},
        { label: 'Status', value: (
            <>
                <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-blue">
                    New
                </div>
            </>
        )
        }
    ]
    return (
        <>
            <PageHeader
                addUrl="/inventory/inventory-adjustment/add"
                listUrl="/inventory/inventory-adjustment"
                viewType={true}
                isHistoryEnabled={true}
                historyData={[historyData]}
            />
            <h5 className="text-start mt-1 mb-3">{pageName}</h5>
            <div className="mt-1 bg-white rounded py-1 px-2 d-flex flex column">
                <DynamicDetailGrid customClassName="my-2 col-10" isExpandable={false} columns={3} data={InventoryAdjustmentHistoryData} />
            </div>
            <div className="mt-2 bg-white rounded py-1 px-4 h-100">
                <Table
                    columns={columns}
                    data={adjustmentdetailslist}
                    CheckboxStatus={false}
                    isStripped={true}
                    customClassName="transferDetailsTable"
                />
            </div>

      <HistoryLayout isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} data={HistoryLaoutAdjustmentDetails} />

        </>
    );
}
